import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import UomActions from '@Actions/uomActions';
import './style.scss';
import PRZSelect from '../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
class SelectUOM extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  // /**
  //  *
  //  * @param props
  //  * @param state
  //  * @return {(*&)|*}
  //  */
  // static getDerivedStateFromProps(props, state) {
  //   const { getUoms, user, uomGroups } = props;
  //   const { isUserReady } = state;
  //   if (user?.tenant_info?.org_id && !isUserReady) {
  //     getUoms(user?.tenant_info?.org_id, 1, 1000, true);
  //     return {
  //       ...state,
  //       isUserReady: true,
  //     };
  //   }
  //   return state;
  // }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      containerClassName, user, onChange, disabled, showError, title, hideTitle, errorOutline, uomGroup, selectedUom, customStyle, excludeUomIds,
    } = this.props;
    // const {} = this.state;
    const uomNameGroup = uomGroup ? user?.tenant_info.uom_groups_master?.[uomGroup]?.uoms : Object.values(user?.tenant_info.uom_groups_master)?.filter((item) => item.uoms !== null)?.map((uomgroup) => [...uomgroup.uoms])?.flat(1);
    return (
      <div className={containerClassName || 'orgInputContainer product__left-input'}>
        {!hideTitle ? (
          <label className="orgFormLabel">
            {title || 'Select Unit of Measure'}
            <span style={{ color: 'red' }}>{'  *'}</span>
          </label>
        ) : <label /> }
        <PRZSelect
          filterOption={false}
          disabled={disabled}
          onChange={(value) => onChange(uomNameGroup.filter((uom) => uom?.uom_id === value)[0])}
          style={
            customStyle || {
              border: errorOutline ? '1px solid red' : 'none',
              borderRadius: '2px',
              height: '28px',
              width: '100%',
              fontSize: '13px',
            }
          }
          value={selectedUom || ''}
        >
          {uomNameGroup && uomNameGroup?.filter((item) => (excludeUomIds ? !excludeUomIds?.includes(item?.uom_id) : true))
            .map((item) => (
              <Option key={item.uom_id} value={item?.uom_id}>
                {`${item.uqc?.toProperCase()} - (${item.uom_name?.toProperCase()})`}
              </Option>
            ))}
        </PRZSelect>
        {showError && (
          <div className="input-error">
            *Please select unit of measure
          </div>
        )}
      </div>

    );
  }
}

const mapStateToProps = ({ UomReducers, UserReducers }) => ({
  getUomsLoading: UomReducers.getUomsLoading,
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
});

SelectUOM.propTypes = {
  user: PropTypes.any,
  uomGroup: PropTypes.any,
  selectedUom: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  errorOutline: PropTypes.bool,
  containerClassName: PropTypes.any,
  customStyle: PropTypes.any,
  excludeUomIds: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectUOM));
